import styled from 'styled-components'
import PropTypes from 'prop-types'

const gridArea = 'colr'
const Wrap = styled.div`
  grid-area: ${gridArea};
  grid-column-start: ${({ start }) => start};
  grid-column-end: 13;
  background-color: ${({ bgColor }) => bgColor};
`
const ColumnRight = ({ children, bgColor = 'white', start = 7, ...rest }) => {
  return (
    <Wrap bgColor={bgColor} start={start} {...rest}>
      {children}
    </Wrap>
  )
}

ColumnRight.propTypes = {
  /** The starting column track */
  start: PropTypes.oneOf([2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}
ColumnRight.slotName = 'PageColumnRight'

export { ColumnRight, gridArea }
